import { makeStyles } from '@mui/styles'
import classNames from 'classnames'
import * as React from 'react'

import MobileAppSelfCheckInDE from '../../../assets/app-self-check-in-promotion/mobile-app-self-check-in-de.png'
import MobileAppSelfCheckInEN from '../../../assets/app-self-check-in-promotion/mobile-app-self-check-in-en.png'
import MobileAppSelfCheckInES from '../../../assets/app-self-check-in-promotion/mobile-app-self-check-in-es.png'
import MobileAppSelfCheckInFR from '../../../assets/app-self-check-in-promotion/mobile-app-self-check-in-fr.png'
import MobileAppSelfCheckInIT from '../../../assets/app-self-check-in-promotion/mobile-app-self-check-in-it.png'
import MobileAppSelfCheckInNL from '../../../assets/app-self-check-in-promotion/mobile-app-self-check-in-nl.png'
import { useIntl } from '../../localization/react'

const useStyles = makeStyles({
  image: (props: Pick<Props, 'size'>) => ({
    height: props.size === 'large' ? 444 : 285,
  }),
})

interface Props {
  size?: 'normal' | 'large'
  className?: string
}

const AppSelfCheckInPromotionImage: React.FC<React.PropsWithChildren<Props>> = ({ size = 'normal', className }) => {
  const intl = useIntl()
  const classes = useStyles({ size })
  const language = intl.context.locale.loaded

  switch (language.toLowerCase()) {
    case 'de':
      return (
        <img
          src={MobileAppSelfCheckInDE as string}
          alt="Mobile Self Check-In"
          className={classNames(classes.image, className)}
        />
      )
    case 'es':
      return (
        <img
          src={MobileAppSelfCheckInES as string}
          alt="Mobile Self Check-In"
          className={classNames(classes.image, className)}
        />
      )
    case 'fr':
      return (
        <img
          src={MobileAppSelfCheckInFR as string}
          alt="Mobile Self Check-In"
          className={classNames(classes.image, className)}
        />
      )
    case 'nl':
      return (
        <img
          src={MobileAppSelfCheckInNL as string}
          alt="Mobile Self Check-In"
          className={classNames(classes.image, className)}
        />
      )
    case 'it':
      return (
        <img
          src={MobileAppSelfCheckInIT as string}
          alt="Mobile Self Check-In"
          className={classNames(classes.image, className)}
        />
      )
    default:
      return (
        <img
          src={MobileAppSelfCheckInEN as string}
          alt="Mobile Self Check-In"
          className={classNames(classes.image, className)}
        />
      )
  }
}

export default AppSelfCheckInPromotionImage
